import {Header} from "../components/Header";
import '../static/css/main.css'
import {useCallback, useEffect, useRef, useState} from "react";
import {Slide, Fade} from "react-awesome-reveal";
import {Footer} from "../components/Footer";
import GoogleMapReact from 'google-map-react';
import '../static/css/banner.css'
import {useNavigate} from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import {
  getDateTime,
  isIOS,
  isPc,
  retrieveData,
  savePageVisit,
  SCREEN_HEIGHT,
  sendRequest,
  storeData
} from "../static/js/common";
import Modal from "react-modal";
import {Carousel} from "react-responsive-carousel";



const Banner = ({ images, speed = 3000 }) => {
  return (
    <div className="inner">
      <div className="wrapper">
        <section className={'banner-section'} style={{ "--speed": `${speed}ms` }}>
          {images.map(({ id, image }) => (
            <div className="image" key={id}>
              <img className={'banner-img'} src={image} alt={id} />
            </div>
          ))}
        </section>
        <section className={'banner-section'} style={{ "--speed": `${speed}ms` }}>
          {images.map(({ id, image }) => (
            <div className="image" key={id}>
              <img className={'banner-img'} src={image} alt={id} />
            </div>
          ))}
        </section>
        <section className={'banner-section'} style={{ "--speed": `${speed}ms` }}>
          {images.map(({ id, image }) => (
            <div className="image" key={id}>
              <img className={'banner-img'} src={image} alt={id} />
            </div>
          ))}
        </section>
      </div>
    </div>
  );
};

const PorfolioBanner = ({ portfolios, isBackwards, isBig, speed = 30000 }) => {

  const navigate = useNavigate();
  const [hover, setHover] = useState(false);

  return (
    <div
      className="portfolio-inner cursor-x"
      style={{height: isBig ? '35vw' : '15.75vw'}}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="wrapper">
        <section className={`${isBackwards ? 'banner-section' : 'banner-forward-section'}`} style={{ "--speed": `${speed}ms` }}>
          {portfolios?.map((item, index) => {
            return (
              <div
                className={`${isPc ? 'portfolio' : 'mobile-portfolio'}`}
                style={{marginLeft: 0}}
                onClick={() => isPc ? navigate(`/works`, {state: {portfolio: item}}) : navigate(`/work-detail/${item?.id}`)}
              >
                <Portfolio item={item} index={index}/>
              </div>
            )
          })}
        </section>
        <section className={`${isBackwards ? 'banner-section' : 'banner-forward-section'}`} style={{ "--speed": `${speed}ms` }}>
          {portfolios?.map((item, index) => {
              return (
                <div
                  key={`portfolio-${item?.id}-${index}`}
                  className={`${isPc ? 'portfolio' : 'mobile-portfolio'}`}
                  style={{marginLeft: 0}}
                  onClick={() => isPc ? navigate(`/works`, {state: {portfolio: item}}) : navigate(`/work-detail/${item?.id}`)}
                >
                  <Portfolio item={item} index={index}/>
                </div>
              )
            })}
        </section>
        <section className={`${isBackwards ? 'banner-section' : 'banner-forward-section'}`} style={{ "--speed": `${speed}ms` }}>
          {portfolios?.map((item, index) => {
              return (
                <div
                  className={`${isPc ? 'portfolio' : 'mobile-portfolio'}`}
                  style={{marginLeft: 0}}
                  onClick={() => isPc ? navigate(`/works`, {state: {portfolio: item}}) : navigate(`/work-detail/${item?.id}`)}
                >
                  <Portfolio item={item} index={index}/>
                </div>
              )
            })}
        </section>
      </div>
    </div>
  );
};


export const Marker = ({}) => {
  return (
    <div className={'flex-row'} style={{marginTop: -60, marginLeft: -34}}>
      <img style={{width: 80}} src={require('../assets/images/red_x.png')} alt="marker"/>
      <div className={'font-16 bold'} style={{minWidth: 200, marginTop: 80}}>휘닉스커뮤니케이션즈</div>
    </div>
  )
}

const Section2 = () => {
  return (
    <div className={'relative'} style={{overflow: 'visible'}}>
      <img className={'width-100'} src={require('../assets/images/main3_bg.png')}/>
      <div className={'absolute'} style={{top: '3vw', left: '3vw'}}>
        <Fade direction={'left'}>
          {/*<img style={{width: '66vw'}} src={require('../assets/images/main3_text.png')}/>*/}
          <div className={'title linear-gradient-text bebas-kai no-letter-spacing'}>NO.1 BX CREACTOR</div>
          <div className={'notosans-bold darkgray margin-top-32 font-1_4vw'} style={{lineHeight: 1.6}}>
            No.1 브랜드를 만드는 No.1 파트너<br/>
            <span className={'notosans-black'}>휘닉스커뮤니케이션즈</span> 입니다.
          </div>
        </Fade>
      </div>
    <div className={'absolute'} style={{bottom: 0, right: 0}}>
      <img style={{width: '46vw'}} src={require('../assets/images/red_x.png')}/>
    </div>
    </div>
  )
}

const Section2Mobile = () => {
  return (
    <div className={'relative'}
         style={{overflow: 'visible', marginTop: 0}}
    >
      <img className={'width-100'} src={require('../assets/images/mobile/mobile_main3_bg.png')}/>
      <div className={'absolute'} style={{top: '20vw', left: '3vw'}}>
        <Fade direction={'left'}>
          <img style={{width: '86vw'}} src={require('../assets/images/main3_text.png')}/>
          <div className={'notosans-regular font-20 margin-top-40'}>
            No.1 브랜드를 만드는 No.1 파트너<br/>
            <span className={'notosans-black'}>휘닉스커뮤니케이션즈</span> 입니다.
          </div>
        </Fade>
      </div>
    <div className={'absolute'} style={{bottom: 0, right: 0}}>
      <Fade direction={'right'}>
        <img style={{width: '46vw'}} src={require('../assets/images/red_x.png')}/>
      </Fade>
    </div>
    </div>
  )
}

const Portfolio = ({item, index}) => {

  return (
    <div className={`flex-column ${isPc ? '' : 'mobile-portfolio'}`}>
      <img className={`${isPc ? 'portfolio-img' : 'mobile-portfolio-img margin-bottom-20'} margin-top-10`} src={item?.mainListImage}/>
      {/*<div className={`white bold font-20 ${isPc ? 'margin-top-12' : ''}`}>{item?.client}</div>*/}
      {/*<div className={'more-blur-white font-16'}>{item?.name}</div>*/}
    </div>
  )
}

export const Main = ({}) => {

  const [portfolios, setPortfolios] = useState([]);
  const [brochureUrl, setBrochureUrl] = useState("");
  const [logos, setLogos] = useState([]);
  const [banners, setBanners] = useState([]);
  const [showBanners, setShowBanners] = useState(false);

  const getBanners = () => {
    const now = new Date()
    sendRequest(`banner/banner/?isExposure=true&now=${getDateTime(now)}`, 'GET', null, async data => {
      setBanners(data)
      if(data?.length) {
        let notShowUntil = await retrieveData('notShowUntil')
        if (!notShowUntil) {
          setShowBanners(true)
        } else {
          notShowUntil = new Date(notShowUntil)
          if (notShowUntil < now) {
            setShowBanners(true)
          }
        }
      }
    })
  }

  const notShowBanner = () => {
    let notShowUntil = new Date()
    notShowUntil.setDate(new Date().getDate() + 5)
    console.log(notShowUntil)
    storeData('notShowUntil', notShowUntil.getTime())
  }

  const getBrochure = () => {
    sendRequest('config/config/?key=BROCHURE', 'GET', null, data => {
      setBrochureUrl(data?.[0]?.file)
    })
  }

  const getPortfolios = () => {
    sendRequest('portfolio/portfolio?size=50&ordering=mainIndex&hasMainIndex=true', 'GET', null, data => {
      console.log(portfolios)
      setPortfolios(data);
    }, (data, code) => {
      console.log(data?.msg)
    }, null)
  }

  const getLogos = () => {
    sendRequest('config/logo/?size=50', 'GET', null, data => {
      setLogos(data)
    })
  }

  const defaultProps = {
    center: {
      lat: 37.508181,
      lng: 127.062797
    },
    zoom: 15
  };

  const logos_ = logos.map((image) => ({
    id: uuidv4().toString(),
    image: image?.image
  }))



  useEffect(() => {
    getLogos()
    getPortfolios()
    getBanners()
    // getBrochure()
    savePageVisit('홈')
  }, [])

  useEffect(() => {
    window.scroll(0, 0)
  }, [])

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '0%',
      width: isPc ? '540px' : '360px',
      height: 'auto',
      maxHeight: isPc ? '580px' : '400px',
      transform: 'translate(-50%, -50%)',
      backgroundColor: '#252525',
      zIndex: 9999,
      position: 'relative',
      overflow: 'hidden',
      padding: 0,
      border: 'none'
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
  };

  return (
    <div>
      <Header/>
      {isPc ?
      <div>
        <div className={'relative main-screen'} style={{marginTop: 80}}>
          <video playsInline autoPlay muted loop className={'width-100'} style={{height: SCREEN_HEIGHT - 160, objectFit: 'cover'}} src={require('../assets/videos/w_main_01.mp4')}/>
          {/*<div className={'absolute'} style={{left: '2vw', top: '8vw'}}>*/}
          {/*  <img style={{width: 6, height: 74}} src={require('../assets/images/dots.png')}/>*/}
          {/*</div>*/}
          {/*<div className={'absolute'} style={{left: '2vw', top: '32vw'}}>*/}
          {/*  <img style={{width: 18, height: 267}} src={require('../assets/images/main1_left_text.png')}/>*/}
          {/*</div>*/}
          {/*<div className={'absolute'} style={{right: '2vw', top: '22vw'}} onClick={() => window.open(brochureUrl)}>*/}
          {/*  <img style={{width: 30, height: 267}} src={require('../assets/images/main1_right_text.png')}/>*/}
          {/*</div>*/}
          <div className={'absolute'} style={{left: 'calc(50% - 51px)', bottom: '7vw'}}
          >
            <img width={142}
                 src={require('../assets/images/big_logo.png')}/>
          </div>
          <div className={'absolute'} style={{left: 'calc(50%)', bottom: '2.5vw'}}>
            <img style={{width: 34 * 0.7, height: 68 * 0.7}} src={require('../assets/images/mouse.png')}/>
          </div>
        </div>
        <div>
          <Banner images={logos_} speed={20000} />
        </div>

        <Section2/>

        <div className={'relative'} style={{marginTop: -5}}>
          <img className={'width-100'} src={require('../assets/images/main4_bg.png')}/>
          <div className={'relative absolute flex-column'} style={{top: '6vw', left: '5vw', width: '100%'}}>
            <Fade direction={'left'}>
              <div className={'title bebas-kai yellow no-letter-spacing'}>BX<br/>INNOVATION</div>
              {/*<img style={{height: '24vw'}} src={require('../assets/images/bx_innovation.png')}/>*/}
            </Fade>
            <div className={'absolute'} style={{bottom: '-3.0vw', left: '38.0vw'}}>
              <Fade direction={'right'}>
                <img style={{width: '7vw'}} src={require('../assets/images/small_red_x.png')}/>
              </Fade>
            </div>
            <div className={'absolute flex-center'} style={{left: '0vw', bottom: '-8vw'}}>
              <div className={'white bold poppins-semibold margin-top-20 text-left font-1_6vw'} style={{lineHeight: 1.8}}>
                새로운 아이디어와 창의적 해결책으로 끊임없는 혁신을 추구하며<br/>
                기존의 한계를 뛰어넘는 브랜드 경험을 디자인합니다.
              </div>
            </div>
          </div>
          <div className={'relative absolute flex-column width-100 align-end'} style={{top: '55vw', right: '5vw'}}>
            <Fade direction={'left'}>
              {/*<img style={{height: '24vw'}} src={require('../assets/images/bx_solution.png')}/>*/}
              <div className={'title bebas-kai yellow no-letter-spacing text-right'}>BX<br/>SOLUTION</div>
            </Fade>
            <div className={'absolute'} style={{bottom: '-3.0vw', right: '-3.0vw'}}>
              <Fade direction={'right'}>
                <img style={{width: '7vw'}} src={require('../assets/images/small_red_x.png')}/>
              </Fade>
            </div>
            <div className={'absolute width-100'} style={{width: '140%', right: '0vw', bottom: '-8vw'}}>
              <div className={'white bold poppins-semibold margin-top-20 text-right width-100 font-1_6vw'} style={{lineHeight: 1.8}}>
                소비자와 환경에 대한 분석에서 시작하여 브랜드의 마케팅 목표를 달성하기 위한<br/>
                최적의 커뮤니케이션 전략과 솔루션을 제공합니다.
              </div>
            </div>
          </div>
        </div>

        <div className={'relative'} style={{marginTop: -5}}>
          <img className={'width-100'} src={require('../assets/images/main4_bg_3.png')}/>
          <div className={'relative absolute flex-column width-100'} style={{top: '6vw', left: '5vw'}}>
            <Fade direction={'left'}>
              {/*<img style={{height: '24vw'}} src={require('../assets/images/bx_engagement.png')}/>*/}
              <div className={'title bebas-kai yellow no-letter-spacing text-left'}>BX<br/>ENGAGEMENT</div>
            </Fade>
            <div className={'absolute'} style={{bottom: '-3.0vw', left: '42.5vw'}}>
            <Fade direction={'right'}>
                <img style={{width: '7vw'}} src={require('../assets/images/small_red_x.png')}/>
              </Fade>
            </div>
            <div className={'absolute flex-center'} style={{left: '0vw', bottom: '-8vw'}}>
              <div className={'white bold poppins-semibold margin-top-20 text-left font-1_6vw'} style={{lineHeight: 1.8}}>
              브랜드 경험을 중점으로 소비자와의 효과적인 연결과 참여를 이끌어내며,<br/>
                브랜드와 고객 간의 지속 가능한 관계를 구축합니다.
              </div>
            </div>
          </div>
        </div>

        <div className={'relative'} style={{marginTop: -5}}>
          {/*<div className={'flex-row'} style={{paddingTop: 54}}>*/}
            {/*<div className={'flex-1'} style={{marginLeft: '2vw'}}>*/}
            {/*  <img style={{width: '20vw'}} src={require('../assets/images/portfolio.png')}/>*/}
            {/*</div>*/}
            {/*<div className={'flex-1 flex-end margin-top-54'} style={{marginRight: '10vw'}}>*/}
            {/*  {categories?.map((item, index) => {*/}
            {/*    const isActive = item === category*/}
            {/*    return (*/}
            {/*      <div onClick={() => setCategory(item)} key={`${item}-${index}`}*/}
            {/*           className={isActive ? 'active-category' : 'inactive-category'}>*/}
            {/*        {item}*/}
            {/*      </div>*/}
            {/*    )*/}
            {/*  })}*/}
            {/*</div>*/}
          {/*</div>*/}
          <div className={'absolute'} style={{top: 0, left: 0}}>
            <img className={'width-100-vw'} style={{height: 'calc(31.5vw + 240px)'}} src={require('../assets/images/main5_bg.png')}/>
          </div>
          <div className={'padding-top-80'}>
            <PorfolioBanner portfolios={portfolios?.filter((a,i) => !(i % 2))} isBackwards={true}/>
          </div>
          <div className={'margin-top-80'}>
            <PorfolioBanner portfolios={portfolios?.filter((a,i) => i % 2)} isBackwards={false}/>
          </div>
          <div className={'padding-top-80'}/>

          {/*<div className={'portfolio-top-wrapper flex-row'} style={{padding: 0}}>*/}
          {/*  */}
          {/*</div>*/}
        </div>
      </div>
      :
        <div className={'black-bg'}>
          <div className={'flex-1 relative'}>
            <video playsInline autoPlay muted loop className={'width-100'} style={{objectFit: 'cover', height: `calc(100vh - ${isIOS() ? '80px' : '40px'})`}} src={require('../assets/videos/m_main_01_.mp4')}/>
            {/*<div className={'absolute'} style={{top: '8%', left: '5%'}}>*/}
            {/*  <img style={{width: '90%'}} src={require('../assets/images/mobile/mobile_main_text.png')}/>*/}
            {/*</div>*/}
            <div className={'absolute'} style={{left: 'calc(50% - 71px)', bottom: '24vw'}}>
              <img width={142} src={require('../assets/images/big_logo.png')}/>
            </div>
          </div>

          <Section2Mobile/>

          <div className={'relative black-bg'} style={{marginTop: -5}}>
            <img className={'width-100'} src={require('../assets/images/mobile/main4_bg.png')}/>
            <div className={'relative absolute flex-column'} style={{top: '10vw', left: '3vw', width: '100%'}}>
              <Fade direction={'left'}>
                <img style={{height: '42vw'}} src={require('../assets/images/mobile/mobile_bx_innovation.png')}/>
              </Fade>
              <div className={'absolute'} style={{bottom: '-14vw', right: '5vw'}}>
                <Fade direction={'right'}>
                  <img style={{width: '20vw'}} src={require('../assets/images/small_red_x.png')}/>
                </Fade>
              </div>
              <div className={'absolute flex-center'} style={{top: '62vw', bottom: '-6vw'}}>
                <div className={'white bold poppins-semibold margin-top-20 font-16 text-left'}
                     style={{lineHeight: 1.8}}>
                  새로운 아이디어와 창의적 해결책으로<br/>
                  끊임없는 혁신을 추구하며<br/>
                  기존의 한계를 뛰어넘는 브랜드 경험을 디자인합니다.
                </div>
              </div>
            </div>
            <div className={'relative absolute flex-column'} style={{top: '98vw', right: '3vw'}}>
              <Fade direction={'left'}>
                <img style={{height: '42vw'}} src={require('../assets/images/mobile/mobile_bx_solution.png')}/>
              </Fade>
              <div className={'absolute'} style={{bottom: '-15vw', right: '-2vw'}}>
                <Fade direction={'right'}>
                  <img style={{width: '20vw'}} src={require('../assets/images/small_red_x.png')}/>
                </Fade>
              </div>
              <div className={'absolute flex-center'} style={{width: '120%', right: 0, top: '62vw', bottom: '-6vw'}}>
                <div className={'white bold poppins-semibold margin-top-20 font-16 text-right'}
                     style={{lineHeight: 1.8}}>
                  소비자와 환경에 대한 분석에서 시작하여<br/>
                  브랜드의 마케팅 목표를 달성하기 위한<br/>
                  최적의 커뮤니케이션 전략과 솔루션을 제공합니다.
                </div>
              </div>
            </div>
          </div>

          <div className={'relative black-bg'}>
            <img className={'width-100'} src={require('../assets/images/mobile/main4_bg_3.png')}/>
            <div className={'relative absolute flex-center flex-column'}
                 style={{top: '14vw', left: '0vw', width: '100%'}}>
              <Fade direction={'left'}>
                <img style={{height: '40vw'}} src={require('../assets/images/mobile/mobile_bx_engagement.png')}/>
              </Fade>
              <div className={'absolute'} style={{bottom: '-15vw', right: '1vw'}}>
                <Fade direction={'right'}>
                  <img style={{width: '20vw'}} src={require('../assets/images/small_red_x.png')}/>
                </Fade>
              </div>
              <div className={'absolute flex-center'} style={{top: '62vw', bottom: '-6vw', left: '4vw'}}>
                <div className={'white bold poppins-semibold margin-top-20 font-16 text-left'}
                     style={{lineHeight: 1.8}}>
                  브랜드 경험을 중점으로 소비자와의<br/>
                  효과적인 연결과 참여를 이끌어내며,<br/>
                  브랜드와 고객 간의 지속 가능한 관계를 구축합니다
                </div>
              </div>
            </div>
          </div>

          <div className={'relative black-bg'}>
            {/*<div className={'flex-row'} style={{paddingTop: 54}}>*/}
            {/*  <div className={'flex-1'} style={{marginLeft: '2vw'}}>*/}
            {/*    <img style={{width: '75vw'}} src={require('../assets/images/portfolio.png')}/>*/}
            {/*  </div>*/}
            {/*</div>*/}

            {/*<div className={'flex-column'} style={{padding: '2.5vw'}}>*/}
            {/*  {portfolios?.map((item, index) => {*/}
            {/*    return (*/}
            {/*      <div*/}
            {/*        className={'width-100'}*/}
            {/*        onClick={() => navigate(`/work-detail/${item?.id}`)}*/}
            {/*      >*/}
            {/*        <Portfolio item={item} index={index}/>*/}
            {/*      </div>*/}
            {/*    )*/}
            {/*  })}*/}
            {/*</div>*/}
            <div className={'padding-top-80'}>
              <PorfolioBanner portfolios={portfolios?.filter((a,i) => !(i % 2))} isBackwards={true} isBig/>
            </div>
            <div className={'margin-top-40'}>
              <PorfolioBanner portfolios={portfolios?.filter((a,i) => (i % 2))} isBackwards={false} isBig/>
            </div>
          </div>
        </div>
      }
      {/*<div className={'black-bg'} style={{height: isPc ? '50vh' : '25vh', width: '100%', paddingTop: isPc ? 0 : 100}}>*/}
      {/*  <GoogleMapReact*/}
      {/*    bootstrapURLKeys={{key: "AIzaSyBiCHb55ZrG9ymhqSS1QeR2S5Cx87tGr5k"}}*/}
      {/*    defaultCenter={defaultProps.center}*/}
      {/*    defaultZoom={defaultProps.zoom}*/}
      {/*    yesIWantToUseGoogleMapApiInternals*/}
      {/*  >*/}
      {/*    <Marker lat={37.508181} lng={127.062797}/>*/}
      {/*  </GoogleMapReact>*/}
      {/*</div>*/}
      <Modal
        isOpen={showBanners}
        // onAfterOpen={afterOpenModal}
        onRequestClose={() => setShowBanners(false)}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className={'relative'}>
          <div className={''} style={{overflowY: 'scroll', overflowX: 'hidden', padding: 0, maxHeight: isPc ? 540 : 360}}>
            <Carousel
              className={'custom-carousel'}
              swipeable={true}
              emulateTouch={true}
              showThumbs={false}
              showArrows={true}
              showIndicators={false}
              showStatus={false}
              autoPlay={false}
              infiniteLoop={false}
              centerMode={false}
              centerSlidePercentage={12}
              width={isPc ? 540 : 360}
              preventMovementUntilSwipeScrollTolerance={true}
              swipeScrollTolerance={20}
              animationHandler={'slide'}
              interval={3000}
              // onChange={index => setIndex(index)}
              renderArrowPrev={(clickHandler, hasPrev, label) => {
                  return (
                    <div onClick={clickHandler} className={'fixed'} style={{left: 0, top: isPc ? 220 : 130, zIndex: 99}}>
                      <img style={{height: 80, width: 30, backgroundColor: '#C52922'}}
                           src={require('../assets/images/works/new_left.png')}/>
                    </div>
                  )
                }}
                renderArrowNext={(clickHandler, hasPrev, label) => {
                  return (
                    <div onClick={clickHandler} className={'fixed'} style={{right: 0, top: isPc ? 220 : 130, zIndex: 99}}>
                      <img style={{height: 80, width: 30, backgroundColor: '#000'}}
                           src={require('../assets/images/works/new_right.png')}/>
                    </div>
                  )
                }}
            >
              {banners?.map((item, index) => {
                return (
                  <div className={'margin-bottom-40'} style={{overflowY: 'scroll', overflowX: 'hidden'}}>
                    <img style={{width: isPc ? 480 : 300}} src={item?.image}/>
                  </div>
                )
              })}
            </Carousel>
          </div>
          <div className={'flex-row fixed width-100 black-bg'} style={{left: 0, bottom: 0, zIndex: 999}}>
            <div className={'flex-row width-100 padding-10'}>
              <div className={'font-16 flex-1 blur-white'} onClick={() => {
                notShowBanner()
                setShowBanners(false)
              }}>5일간 보지 않기</div>
              <div className={'font-16 flex-end blur-white'} onClick={() => setShowBanners(false)}>닫기</div>
            </div>
          </div>
        </div>
      </Modal>
      <Footer/>
    </div>
  )
}
